'use client';

import type { Dispatch, SetStateAction } from 'react';
import type { Area } from '@/types/booliApi';
import type { PreviewIndices } from '.';

const AreaTabs = ({
  areas,
  indices,
  setIndices,
}: {
  areas: Area[];
  indices: PreviewIndices;
  setIndices: Dispatch<SetStateAction<PreviewIndices>>;
}) => {
  return (
    <div
      className='scrollbar tablet:w-full tablet:flex-none tablet:justify-start mb-14 flex flex-nowrap justify-center
        overflow-x-auto whitespace-nowrap'
    >
      {areas.map((area: Area) => {
        return (
          <button
            type='button'
            key={area.id}
            className={`border-bui-color-black/8 cursor-pointer border-b-2 px-4 py-2 transition-all duration-300 ${
              indices.ids === area.id
                ? 'border-bui-color-orange! text-bui-color-black'
                : 'text-bui-color-black/60 hover:border-bui-color-black/16 hover:text-bui-color-black/100'
            }`}
            onClick={() => setIndices((prev) => ({ ...prev, ids: area.id }))}
          >
            {area.name}
          </button>
        );
      })}
    </div>
  );
};

export default AreaTabs;
